import React, { ChangeEvent } from "react";
import Form from "react-bootstrap/Form";
import classes from "./StateSelector.module.scss";

interface Props {
  region: string | null;
  onChange: (event: string) => void;
}

function StateSelector({ region, onChange }: Props) {
  const onChangeEvent = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.currentTarget.value);
  };

  const regions = ["WA", "VIC", "QLD", "NSW"];

  return (
    <div className={`d-flex gap-3 mb-3 ${classes.selector} square-check`}>
      {regions.map((_region) => (
        <Form.Check
          key={_region}
          type={"radio"}
          name="region"
          id={`region-${_region}`}
          label={_region}
          value={_region}
          checked={region === _region}
          onChange={onChangeEvent}
        />
      ))}
      <Form.Check
        type={"radio"}
        name="region"
        id="region-All"
        label={"All"}
        value={""}
        checked={!region}
        onChange={onChangeEvent}
      />
    </div>
  );
}

export default StateSelector;
